import { Types } from "../Constants/Types";
import WarehouseOpsType from "../Interfaces/warehouse-ops.interface";

const PackingReducer = (
  state: WarehouseOpsType["packingState"] = {
    order: undefined,
    lorder: false,
    lscan: false,
  },
  action: WarehouseOpsType["action"]
) => {
  switch (action.type) {
    case Types.FETCH_PACKING_ORDER:
      return { ...state, order: action.payload ?? undefined };

    case Types.RESET_PACKING_ORDER:
      return { ...state, order: undefined };

    // Patch the in-memory order after a scan with fresh progress + packed flags.
    case Types.UPDATE_PACKING_ORDER:
      return { ...state, order: action.payload };

    case Types.START_PACKING_ORDER:
      return { ...state, lorder: true };

    case Types.END_PACKING_ORDER:
      return { ...state, lorder: false };

    case Types.START_PACKING_SCAN:
      return { ...state, lscan: true };

    case Types.END_PACKING_SCAN:
      return { ...state, lscan: false };

    default:
      return state;
  }
};

export default PackingReducer;
